import * as TypeGraphQL from "type-graphql";
export var MarketSentimentContext;
(function (MarketSentimentContext) {
    MarketSentimentContext["VERY_BEARISH"] = "VERY_BEARISH";
    MarketSentimentContext["BEARISH"] = "BEARISH";
    MarketSentimentContext["NEUTRAL"] = "NEUTRAL";
    MarketSentimentContext["BULLISH"] = "BULLISH";
    MarketSentimentContext["VERY_BULLISH"] = "VERY_BULLISH";
})(MarketSentimentContext || (MarketSentimentContext = {}));
TypeGraphQL.registerEnumType(MarketSentimentContext, {
    name: "MarketSentimentContext",
    description: undefined,
});
//# sourceMappingURL=MarketSentimentContext.js.map